var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdUnitHeader',{attrs:{"name":_vm.name},on:{"provideMoreDetails":_vm.exportProvideMoreDetails}})}
var staticRenderFns = []

export { render, staticRenderFns }